import type { FaireProductEntity } from "../../entity_types/product";

export const p_tvjqzy4zr2: FaireProductEntity = {
  token: "p_tvjqzy4zr2",
  type: "product",
  name: "Highlighter and Bronzer Sets",
  brandToken: "b_3d2wzlqi",
  brandName: "River Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/2611bb3abfdea1fc9b97fb43ba7e449f18d95149b07f9f6a0d052311cab01dbd.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/afcc199a82d25b547c82130bca8a5aa001322eb096955d7e744951b7940595dc.png",
    "https://cdn.faire.com/fastly/3c5864bc9e254f1bd60d28e9c53d1b3a148f763fa1506f5121e0c13c54cbb2b2.jpeg",
    "https://cdn.faire.com/fastly/3cc1c7601dacf849d6ebda7b362bdbede201c47318328c65977604e9ec225a70.png",
    "https://cdn.faire.com/fastly/df71950d2074a7dfb4db832b770450989f0d8814cb354ea4818e9203d0f7c943.png",
    "https://cdn.faire.com/fastly/f17688e922df8ff965b778f13631559ba5335ccbee1ab981030aebdefcf65815.jpeg",
    "https://cdn.faire.com/fastly/63a1730d6c8e7b841802d75cc3934dbbd3ce254cb281f09f7c7df087d58465f4.jpeg",
    "https://cdn.faire.com/fastly/d7e497e53fff4bd434ceb4136d7074471d43048770216b036c343f26d81e3d0b.jpeg",
    "https://cdn.faire.com/fastly/d6151bdefdd4bcce672723964efa37e56d341ef1650843bf008d174a4fb7baa9.png",
    "https://cdn.faire.com/fastly/019b28bbe4ef4911c3943e52d220e6eeb0c2e2917a70dfea9ecf39349a6b945e.jpeg",
    "https://cdn.faire.com/fastly/cd75a0e0e999d069f017020957738a13f326b111977b12959f0bea30e91fb40d.jpeg",
    "https://cdn.faire.com/fastly/a23fca82829e56e53453b31a321fb171bdd752d4ccb92ed9b1d7d0868682e495.jpeg",
    "https://cdn.faire.com/fastly/d13b90d8d1a905a58a34182c2cac95ba12a0e8dc117638a35cea6332589bd911.jpeg",
  ],
  priceDollars: 19.99,
  description:
    "A set of two or three vegan makeup sticks to brighten and soothe the skin!\nMix and match or get all three! \n*All Sets come in Gift Boxes\n*Bronzer - The bronzing highlighting makeup gives you a light bronze shimmer for face and body, also works great as a highlighter on dark skin tones.\n*Rose Quartz Highlighter - An iridescent highlighting makeup that gives you a healthy dewy translucent look.\n*Illumi ->Illumi has a champagne gold sheen to light up the skin.\n\nFEATURED INGREDIENTS - We use Rosehip, Grapeseed oil and Shea Butter to protect and firm the gentle skin where the highlighters and bronzers are used.\n\nSCENT - No scent is added, the natural scent of the highlighter and bronzer is light cacao.\n\nHOW TO USE: Push up gently from the bottom and apply to desired areas.\n-100% Vegan\n-Cruelty-free Certified\n-Vegan Trademark Certified\n-Eco-Friendly Paper Packaging\n\nNet Weight .50 oz / 14g\n\nINGREDIENTS: *Shea Butter, *Cocoa Seed Butter, Candelilla Wax, Grapeseed Oil, Rose Hip Seed Oil, Toco",
  tags: [],
  msrpDollars: 39.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:23.370Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
